
"use strict";
import {Injectable, Inject} from 'ng-metadata/core';
import {MappingTablesCache} from '../../../../../mappingTablesCache/mappingTablesCache.service'
import appConfigModule from '../../../../../appConfig/appConfig.module';


/**
 * Represent Location item.
 */
class LocationItem{
    public callnumber;
    public callnumber2;
    public copyid;
    public holdingrecordid;
    public itembarcode;
    public itemcategorycode;
    public itemcategoryname;
    public itemdescription;
    public itemid;
    public itemmaterial;
    public itemrecordid;
    public itemstatusname;
    public listofservices;
    public mainlocationcode;
    public mainlocationname;
    public noteopac;
    public pages;
    public processingstatus;
    public queue;
    public secondarylocationcode;
    public secondarylocationname;
    public volume;
    public year;

    constructor(ilsLocationItem:any, public builder:LocationBuilder, vid){
        this.update(ilsLocationItem, vid);
    }

    update(locationValues, vid){
        Object.keys(locationValues).forEach((field) => {
            this[field] = locationValues[field];
        });
    }

}

/**
 * Location item with additional methods to easy display the brief/full lines
 */
export class LocationItemDisplay extends LocationItem{

    public isExpanded:boolean;

    private _fullDisplayValues:Array<KeyValue>;

    constructor(ilsLocationItem:any, builder, vid){
        super(ilsLocationItem, builder, vid);
        this.isExpanded = false;
    }

    update(locationValues, vid) {
        super.update(locationValues, vid);

        this.fullDisplayValues = this.builder.getFullDisplayFields(vid).map((field) => {
            return new KeyValue(field[1], this[field[1].replace(/_/g, '')]);
        }).filter((entry:KeyValue) => {
            return entry.value != null
        });
    }
    /**
     *
     * @returns string
     */
//    getBriefDisplayLine(vid){
//        let conf = this.builder.getBriefDisplayFields(vid);
//        return conf.fields.map((field)=> {
//            return this[field]
//        }).join(conf.delimiter)
//    }

    set fullDisplayValues(fullDisplayValues){
        this._fullDisplayValues = fullDisplayValues
    }
    get fullDisplayValues(){
        return this._fullDisplayValues;
    }
}

/**
 * Builder class for LocationItem.
 * Use configuration in order to parse and diaply location item
 */
@Injectable()
export class LocationBuilder{

    private fullDisplayFields:Array<string> = [];
    private fullPropertiesType:string = 'item.global.dataitem';
    private noOfItemsType:string = 'number_of_items';
    public itemsListConf:Array<Array<string>> = [];
    private summaryHoldingsFields: Array<string> = [];
    public noOfItems: string = '';
    private itemsConfig:any;

    constructor(private mtCache: MappingTablesCache) {
    }

    getBriefDisplayFields(vid){
        this.itemsListConf = [];
        for(let i = 1; i <= 4; i++) {
            this.itemsConfig = this.getLocationsConfig(this.mtCache.tables.ITEMS_BRIEF_DISPLAY, 'item.brief.' + i, vid);
            if (this.itemsConfig[0]) {
                this.itemsListConf.push([this.itemsConfig[0].source3, this.itemsConfig[0].source4, this.itemsConfig[0].source5, this.itemsConfig[0].target]);
            }
        }
        return this.itemsListConf;
    }

    getLocationsConfig(configTable, configName, vid){
        let row= this.mtCache.findByProperties(configTable, {source1: vid, source2: configName});
        if (row.length> 0){
            return row;
        }
        return this.mtCache.findByProperties(configTable, {source1: 'default', source2: configName});
    }

    getFullDisplayFields(vid){
        if (this.fullDisplayFields.length === 0) {
            let fields = this.getDetailedDisplayFieldsConfiguration(vid);
            let alreadyUsed =[];
            this.getBriefDisplayFields(vid).map((usedField)=>{
                usedField.map((field)=>{alreadyUsed.push((field?field.replace(/_/g, ''):''))});
            });

            fields = fields.filter((field)=> {
                let nuiField = field[1].replace(/_/g, '');//the second ([1]) place is of target col - the item code
                return (alreadyUsed.indexOf(nuiField) === -1)
            });

            this.fullDisplayFields = fields;
        }

        return this.fullDisplayFields;
    }

    private getDetailedDisplayFieldsConfiguration(vid){
        let viewRows = this.mtCache.findByProperties(this.mtCache.tables.LOCATION_ITEM_CONTENT, {source1: vid});
        let defaultRows = this.mtCache.findByProperties(this.mtCache.tables.LOCATION_ITEM_CONTENT, {source1: 'default'});
        let filteredRows= viewRows.filter((item)=>{if (item.source2.includes(this.noOfItemsType)) return item});
        if (filteredRows.length === 0){
            filteredRows= defaultRows.filter((item)=>{if (item.source2.includes(this.noOfItemsType)) return item});
        }
        this.noOfItems = filteredRows[0]? filteredRows[0].target : '0';//item.brief.number_of_items
        let rows= viewRows.length > 0? viewRows : defaultRows;
        return rows.filter((item)=>{if (item.source2.includes(this.fullPropertiesType)) return item;})
            .sort((a,b) => {

                let aNum = a.source2.substr(a.source2.lastIndexOf('.')+1, a.source2.length-1);
                let bNum = b.source2.substr(b.source2.lastIndexOf('.')+1, b.source2.length-1);
//                console.log('aNum,bNum=' + aNum + ',' + bNum + '. ss:' + (parseInt(aNum) - parseInt(bNum)));
                return (parseInt(aNum) - parseInt(bNum));
            })
            .map((row) => {
                let target = row.target.replace(/_/g, '');
                let rowData = [row.source2, target]
                return rowData;
            })
    }

    public getOrderedSummaryHoldingsInfoConfiguration(vid, adaptor){
        let rows = this.mtCache.findByProperties(this.mtCache.tables.HOLDINGS_RECORD_CONFIG, {source1: vid, source3:adaptor});
        if (rows.length === 0){
            rows = this.mtCache.findByProperties(this.mtCache.tables.HOLDINGS_RECORD_CONFIG, {source1: 'default', source3:adaptor});
        }
        if (rows.length === 0){
            rows = this.mtCache.findByProperties(this.mtCache.tables.HOLDINGS_RECORD_CONFIG, {source1: vid, source3: 'Default'});
        }
        if (rows.length === 0){
            rows = this.mtCache.findByProperties(this.mtCache.tables.HOLDINGS_RECORD_CONFIG, {source1: 'default', source3: 'Default'});
        }

        this.summaryHoldingsFields = rows
            .sort((a,b) => {
                return (parseInt(a.source4) - parseInt(b.source4))
            })
            .map((row) => {
                return row.source2;//.replace(/_/g, '');
            });
        return this.summaryHoldingsFields;
    }

    getShowMoreBulkSize() {
        let row= this.mtCache.findByProperties(this.mtCache.tables.BULK_DEFINITION, {source1: 'OvP - Items Paging'});
        if (row.length> 0){
            return Number(row[0].target);
        }
        return 0;
    }
}

class KeyValue{
    public key:string;
    public value:string;

    constructor(key, value){
        this.key = key;
        this.value = value;
    }
}

export default [appConfigModule.name];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/locationItemModel.service.ts